export const ServerStatus = Object.freeze({
  ACTIVE: 1,
  ERROR: 2,
});

const LAST_UPDATED_AT_TIMEOUT_MIN = 20;
const LAST_UPDATED_AT_TIMEOUT_MS = LAST_UPDATED_AT_TIMEOUT_MIN * 60 * 1000;


/**
 * @param {string} data.data - server info last updated at date
 * @param {number} data.squid - squid status
 * @param {number} data.fw - fw status
 * @param {number} data.samba - samba status
 * @param {number} data.http - http status
 * @param {number} data.vpn - vpn status
 * @param {number} data.maquina - maquina status
 * @param {number} data.dhcp - dhcp status
 * @param {number} data.rede - rede status
 * @param {number} data.dns - dns status
 * @param {number} data.mysql - mysql status
 * @param {number} data.rsync - rsync status
 * @param {number} data.disco - disco status
 * @param {number} data.memoria - memoria status
 * @param {number} data.bkp - bkp status
 */
export function isServerAlertActive(server) {
  return (server.squid === ServerStatus.ERROR) ||
    (server.fw === ServerStatus.ERROR) ||
    (server.samba === ServerStatus.ERROR) ||
    (server.http === ServerStatus.ERROR) ||
    (server.vpn === ServerStatus.ERROR) ||
    (server.maquina === ServerStatus.ERROR) ||
    (server.dhcp === ServerStatus.ERROR) ||
    (server.rede === ServerStatus.ERROR) ||
    (server.dns === ServerStatus.ERROR) ||
    (server.mysql === ServerStatus.ERROR) ||
    (server.rsync === ServerStatus.ERROR) ||
    (server.disco === ServerStatus.ERROR) ||
    (server.memoria === ServerStatus.ERROR) ||
    (server.bkp === ServerStatus.ERROR) ||
    isServerDataOutDated(server.data);
}

/**
 * @param {string | undefined} date - last updated date
 * @returns {boolean} whether the info is outdated or not
 */
export function isServerDataOutDated(date) {
  const now = new Date();
  const lastUpdatedAt = new Date(date);
  return (undefined == date) || ((now - lastUpdatedAt) > LAST_UPDATED_AT_TIMEOUT_MS);
}
